module.exports = __webpack_public_path__ + "fonts/Noto_Serif_JP-400-509.4760bef.woff2";